<template>
 <div class="platform" >
   <div class="right" >
     <div class="centre" >
       <h1 class="title" >Data platform for wearables</h1>
     </div>
   </div>
   <div class="centre" >
     <div class="data">
      <div class="topic">
        <img src="@/assets/table.png">
      </div>
     </div>
   </div>
 </div>
</template>

<script>
export default {
  name: "platform.vue"
}
</script>

<style scoped>


  .centre {
    width: 1246px;
    margin: 0 auto;
  }

  .right {
    background-color: #f5f6f8;
  }

  .right .centre {
    display: flex;
    justify-content: flex-end;
  }


  .centre .title {
    margin-right: 80px;
    height: 178px;
    font-weight: 700;
    font-size: 36px;
    line-height: 178px;
  }

  .centre .data {
    width: 1246px;
    margin: 0 auto;
  }

  .centre .data .topic {
    padding-top: 80px;
    line-height: 0;
  }

  .centre .data .topic img {
    width: 1266px;
  }


</style>